define('appkit/region.controller',[
  'underscore',
  'backbone',
  'marionette'
], function(
  _,
  Backbone,
  Mn
) {

  // Abstract Class for implementing a region
  // controller
  function RegionController(app, region, state) {
    this.app = app;
    this.region = region;
    this.state = state;
    this.configureStateEvents();
    this.initialize.apply(this, arguments);
  };

  RegionController.extend = Backbone.Model.extend;

  _.extend(RegionController.prototype, Backbone.Events, {

    proxyStateEvents: ['page:error', 'page:exit', 'page:loaded', 'page:cancel'],

    initialize: function() {

    },

    configureStateEvents: function() {
      _.each(this.proxyStateEvents, function(event) {
        this.listenTo(this.state, event, function() {
          var args = _.toArray(arguments);
          this.triggerMethod.apply(this, [event].concat(args));
        }, this);
      }, this);
      // we always want to stop when the page:exit event
      // is triggered
      this.listenTo(this.state, 'page:exit', this.stop);
    },

    model: function(name) {
      return this.app.model(name);
    },

    request: function() {
      return this.app.request.apply(this.app, arguments);
    },

    start: function() {
      this.triggerMethod('before:start', this);
      this.triggerMethod('start', this);
      return this;
    },

    stop: function() {
      // clean me up when
      // we leave the page
      this.triggerMethod('before:stop', this);
      this.triggerMethod('stop', this);
      this.off().stopListening();
      return this;
    },

    triggerMethod: Mn.triggerMethod

  });

  return RegionController;
});

